import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { usageApi } from '../api';
import type { UsageEventQuery, UsageSummaryQuery, UsageUserQuery } from '../api/usage';

export const useUsageSummary = (query: UsageSummaryQuery, enabled: boolean) =>
  useQuery({
    queryKey: ['usage', 'summary', query],
    queryFn: () => usageApi.summary(query),
    enabled,
    refetchOnWindowFocus: false,
  });

export const useUserUsage = (query: UsageUserQuery, enabled: boolean) =>
  useQuery({
    queryKey: ['usage', 'users', query],
    queryFn: () => usageApi.users(query),
    enabled,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });

export const useUsageEvents = (query: UsageEventQuery, enabled: boolean) =>
  useQuery({
    queryKey: ['usage', 'events', query],
    queryFn: () => usageApi.events(query),
    enabled,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });

/** 대화 원문 — 열 때마다 서버가 감사 로그를 남기므로 펼친 행만, 다시 묻지 않는다. */
export const useUsageTurn = (eventId: string | null) =>
  useQuery({
    queryKey: ['usage', 'turn', eventId],
    queryFn: () => usageApi.turn(eventId as string),
    enabled: eventId !== null,
    staleTime: Infinity,
    retry: false,
  });

export const useUsagePrices = (enabled: boolean) =>
  useQuery({
    queryKey: ['usage', 'prices'],
    queryFn: () => usageApi.prices(),
    enabled,
    staleTime: 5 * 60_000,
  });
